import React, { useState } from 'react';
import { Box, Skeleton, Fade } from '@mui/material';

interface LoadingImageProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  className?: string;
}

const LoadingImage: React.FC<LoadingImageProps> = ({ src, alt, style, className }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <Box sx={{ position: 'relative', ...style }} className={className}>
      {loading && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />
      )}
      
      {!error && (
        <Fade in={!loading} timeout={500}>
          <img
            src={src}
            alt={alt}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: loading ? 'none' : 'block',
            }}
            onLoad={handleLoad}
            onError={handleError}
          />
        </Fade>
      )}
      
      {error && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'grey.100',
            color: 'text.secondary',
          }}
        >
          Resim yüklenemedi
        </Box>
      )}
    </Box>
  );
};

export default LoadingImage;
